import { Component, OnInit, Input, Optional } from '@angular/core';
import { environment } from 'environments/environment';
import { AccountService } from '../account.service';
import { LanguageService } from 'app/services/language.service';
import { User } from '../../interfaces/user';
import { FirebaseService } from 'app/services/firebase.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ContribService } from 'app/+projects/contrib/contrib.service';
import { CurrentUser } from 'app/services/currentUser.service';
import { UserAccount } from 'app/services/userAccount.service';
import { WaitingComponent } from 'app/+projects/contribWizard/waiting/waiting.component';
import { FacebookPixelService } from 'app/services/facebook-pixel.service';

@Component({
  selector: 'app-email-sign-up',
  templateUrl: './email-sign-up.component.html',
  styleUrls: ['./email-sign-up.component.scss', '../account.scss']
})
export class EmailSignUpComponent implements OnInit {
  @Input() updateGuest;
  @Input() noPhotos;
  user = new User();
  // user: User = {
  //   username: '',
  //   password: '',
  //   first_name: '',
  //   last_name: '',
  //   profile: {
  //     country: environment.countries[0],
  //     language: this.languageService.getBrowserLang(), // supports en & fr
  //     mobile_number: '',
  //   },
  // };

  errors = {
    username: '',
    password: '',
    first_name: '',
    last_name: '',
    terms: false,
  };

  isLoading;
  termsOfUseAccepted;
  privacyPolicyAccepted;

  privacyPolicyLink = environment.privacyPolicyLink;
  termsOfUseLink = environment.termsOfUseLink;

  constructor(
    public accountService: AccountService,
    private languageService: LanguageService,
    public firebaseService: FirebaseService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private facebookPixelService: FacebookPixelService,
    @Optional() private contribService: ContribService,
    @Optional() private currentUser: CurrentUser,
    @Optional() private userAccount: UserAccount,
    @Optional() private waintingComponent: WaitingComponent,
  ) { }

  ngOnInit() {
  }

  isUserValid() {
    return (
      this.user.password &&
      this.user.username &&
      this.user.first_name &&
      this.user.last_name &&
      !this.isLoading
    );
  }

  onSubmit() {
    if (!this.termsOfUseAccepted || !this.privacyPolicyAccepted) {
      this.errors.terms = true;
      return null;
    }
    this.errors.terms = false;
    this.isLoading = true;
    if (this.updateGuest || this.activatedRoute.snapshot.queryParamMap.get('contrib')) {
      this.currentUser.updateGuest(this.user).subscribe(x => {
        this.currentUser.updateCurrentUser(this.user);
        this.userAccount.set(this.user);
        this.router.navigate(['/stories']);
      });

    } else {
      this.accountService.signUp(this.user).subscribe(
            data => {
              this.firebaseService.setUserId(data.user_id);
              this.firebaseService.logEvent('sign_up', {
                method: 'email',
              });
              this.facebookPixelService.trackEvent('CompleteRegistration' , {
                method: 'email',
              });
              this.firebaseService.userProperties({ first_open_time: new Date() });
              this.isLoading = false;
            },
            errors => {
              this.isLoading = false;
              this.errors = errors;
              if (errors.status === 409) {
                this.router.navigate(['/account/login/email/'], { queryParams: { cred: this.user.username}});
              }
              this.firebaseService.logEvent('sign_up_error', {
                reason: errors.detail,
              });
            }
          );
    }
  }

}
